import { TrackEventArgsType, TrackEventNameType } from '../@types/schema';

import { trackActionTracker } from './trackers/action-tracker';
import { sendWebAnalyticsEvent } from './trackers/lead-connector-tracker';
import { newRelicTrack } from './trackers/newrelic-tracker';
import transformParams from './transform-params';

/**
 * Tracks an event, sends information to newrelic, action-tracker, and lead-connector
 */
export const track = async (eventName: TrackEventNameType, args: TrackEventArgsType) => {
  try {
    const { newrelicMetadata, ...restOfArgs } = args;
    const transformed = transformParams(eventName, restOfArgs);

    newRelicTrack(eventName, newrelicMetadata, transformed);

    sendWebAnalyticsEvent(eventName, {
      category: restOfArgs.category as string | undefined,
      label: restOfArgs.label as string | undefined,
      value: restOfArgs.value as string | undefined,
    });

    return await trackActionTracker(eventName, transformed);
  } catch (err) {
    window['newrelic']?.noticeError(err);
    throw new Error(`Failed to track event ${eventName} - ${JSON.stringify(args)} - ${err}`);
  }
};
